var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.343 15.857 4.864 21.515c-.128.064-.257.128-.385.128l8.164-8.678zM11.743 12l-8.486 9.129A1.24 1.24 0 0 1 3 20.357V3.643c0-.257.064-.515.257-.707zm8.55-1.157c.45.193.707.643.707 1.157s-.257.9-.707 1.157L16.5 15.215 13.479 12 16.5 8.786zM4.479 2.357c.192.065.321.065.385.13l10.479 5.656-2.7 2.893z"
  })));
};
export default SvgGooglePlay;